<template>
  <div id="registrar-detail" v-if="detail.id !==''">
    <table class="unstriped">
      <tbody>
      <tr>
        <td>{{ 'Registrar ID'|t }}:</td>
        <td>{{ detail.id }}</td>
      </tr>
      <tr>
        <td>{{ 'Created'|t }}:</td>
        <td>{{ detail.created_at|date }}</td>
      </tr>
      <tr>
        <td>{{ 'Credit'|t }}:</td>
        <td>{{ detail.credit }}</td>
      </tr>
      <tr>
        <td>{{ 'IANA Registrar ID'|t }}:</td>
        <td>{{ detail.iana_registrar_id < 1 ? '' : detail.iana_registrar_id }}</td>
      </tr>
      <tr>
        <td>{{ 'Address'|t }}:</td>
        <td>
          <a :href="mapLink()" target="_blank">
            <address>
              {{ detail.name }},
              {{ detail.org }},
              {{ detail.street }} {{ detail.city }},
              {{ detail.state }},
              {{ detail.country }}
            </address>
          </a>
        </td>
      </tr>
      <tr>
        <td>{{ 'E-mail address'|t }}:</td>
        <td><a :href="'mailto:' + detail.email">{{ detail.email }}</a></td>
      </tr>
      <tr v-if="detail.abuse_email.length > 0">
        <td>{{ 'Abuse e-mail address'|t }}:</td>
        <td><a :href="'mailto:' + detail.abuse_email">{{ detail.abuse_email }}</a></td>
      </tr>
      <tr v-if="detail.abuse_telephone.length > 0">
        <td>{{ 'Abuse telephone'|t }}:</td>
        <td><a :href="'tel:' + clearPhone(detail.abuse_telephone)">{{ detail.abuse_telephone }}</a></td>
      </tr>
      <tr>
        <td>{{ 'Telephone'|t }}:</td>
        <td><a :href="'tel:' + clearPhone(detail.phone)">{{ detail.phone }}</a></td>
      </tr>
      <tr>
        <td>{{ 'Fax'|t }}:</td>
        <td>{{ detail.fax }}</td>
      </tr>
      <tr>
        <td>{{ 'Website'|t }}:</td>
        <td><a :href="detail.website" target="_blank">{{ detail.website }}</a></td>
      </tr>
      <tr v-if="commandChecks !== null">
        <td>{{ 'Command Checks'|t }}:</td>
        <td>
          <template v-for="check in checkList()">
            <div><span :class="'badge ' + checkColor(check)"><i :class="'icon icon-' + checkIcon(check)"></i></span> {{ check }}</div>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import api from '@/api';

  export default {
    name: 'Detail',
    props: {
      id: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        detail: {
          id: ""
        },
        commandChecks: null,
      }
    },
    created() {
      api.viewRegistrar(
        { registrar_id: this.id },
        data => this.detail = data
      );

      let user = this.$store.getters['user']();
      if (user.epp_extensions.indexOf('http://regtonsregistry.cz/commandCheck') > -1) {
        api.registrarCommandChecks(
          { registrar_id: this.id },
          data => this.commandChecks = data.checks
        );
      }
    },
    methods: {
      clearPhone(num) {
        let cp = num;
        return cp.replace('.', '')
      },
      mapLink() {
        let q = this.detail.org + ", " + this.detail.street + " " + this.detail.city + ", " + this.detail.state + ", " + this.detail.country;
        return 'https://www.google.com/maps/search/' + q;
      },
      checkList() {
        return [
          "contact:create",
          "contact:delete",
          "contact:check",
          "contact:info",
          "contact:update",
          "domain:create",
          "domain:delete",
          "domain:check",
          "domain:info",
          "domain:renew",
          "domain:restore:report",
          "domain:restore:request",
          "domain:transfer:approve",
          "domain:transfer:cancel",
          "domain:transfer:query",
          "domain:transfer:reject",
          "domain:transfer:request",
          "domain:update",
          "host:create",
          "host:delete",
          "host:check",
          "host:info",
          "host:update",
          "login",
          "logout",
          "poll:ack",
          "poll:req",
        ]
      },
      checkIcon(name) {
        if (typeof this.commandChecks !== "object" && !(this.commandChecks instanceof Array)) {
          return "blocked";
        }
        return this.commandChecks.indexOf(name) === -1 ? "cross" : "checkmark";
      },
      checkColor(name) {
        if (typeof this.commandChecks !== "object" && !(this.commandChecks instanceof Array)) {
          return "alert";
        }
        return this.commandChecks.indexOf(name) === -1 ? "warning" : "success";
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/registrar/Detail.vue